const state = {
  files: []
}

const getters = {
  successCnt: (state, getters) => {
    let cnt = 0
    state.files.forEach((file, i) => {
      if (file.success) { cnt++ }
    })
    return cnt
  }
}

const mutations = {
  updateFiles (state, files) {
    // console.log('updateFiles: ' + files)
    state.files = files
  },
  clearFiles (state) {
    state.files = []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
